import { useEffect } from 'react'
import { useAuth } from '../context/AuthContext'
import { useAnalytics } from '../context/AnalyticsContext'

/**
 * Вызывает posthog.identify(userId) при появлении пользователя.
 * Нужно для корректного DAU/WAU/MAU и привязки событий к пользователю.
 */
export default function PostHogIdentify() {
  const { user } = useAuth()
  const { identifyUser } = useAnalytics()

  useEffect(() => {
    if (user?.id) identifyUser(user.id)
  }, [user?.id, identifyUser])

  return null
}
